/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { ApplicationConfigWithPages } from '../../../shared/features/ng-redux/app/appConfig.models';

import {
  APP_SPOTLIGHT_APP,
  APP_SPOTLIGHT_APP_W,
  APP_USAGE_APP,
  APP_USAGE_APP_W,
  APP_USAGE_SHIFT_APP,
  APP_USAGE_SHIFT_APP_W,
  BATTERY_APP,
  BATTERY_APP_W,
  WEB_APP_SPOTLIGHT_APP,
  DATA_USAGE_APP,
  DATA_USAGE_APP_W,
  DEVICE_APP,
  DEVICE_APP_W,
  LAST_KNOWN_APP,
  LAST_KNOWN_APP_W,
  SIGNAL_STRENGTH_APP,
  SIGNAL_STRENGTH_APP_W,
  SMART_BATTERY_APP,
  WATCHLIST_APP,
  WATCHLIST_CURRENT_APP,
  WATCHLIST_DEPARTED_APP,
  WEBAPP_USAGE_APP,
  WIFI_APP,
  WIFI_APP_W,
  UTILIZATION_DEVICE_APP,
  UTILIZATION_STORE_APP,
} from './app-mapper.constants';

import { mapAppSpotlightConfig } from './app-mapper.as';
import {
  mapAppUsageConfig,
  mapAppUsageShiftConfig,
  mapBatteryUsageConfig,
  mapDataUsageConfig,
  mapWebAppUsageConfig,
  mapWifiConfig,
} from './app-mapper.device';
import { mapDeviceConfig } from './app-mapper.sdd';
import { mapSmartBatteryConfig } from './app-mapper.smart-battery';
import { mapWatchlistConfig, mapWatchlistCurrentConfig, mapWatchlistDepartedConfig } from './app-mapper.watchlist';
import { mapLastKnownConfig, mapSignalStrengthConfig } from './app-mapper.device.loc';
import {
  mapAppUsageShiftWindowsConfig,
  mapAppUsageWindowsConfig,
  mapBatteryUsageWindowsConfig,
  mapDataUsageWindowsConfig,
  mapWifiWindowsConfig,
} from './app-mapper.device.win';
import { mapLastKnownWindowsConfig, mapSignalStrengthWindowsConfig } from './app-mapper.device.win.loc';
import { mapWindowsDeviceConfig } from './app-mapper.sdd.win';
import { mapWebAppSpotlightConfig } from './app-mapper.waps';
import { mapUtilizationDeviceConfig, mapUtilizationStoreConfig } from './app-mapper.util';
import { mapAppSpotlightWindowsConfig } from './app-mapper.as.win';

export function mapAppConfig(
  app: ApplicationConfigWithPages,
  devApp: ApplicationConfigWithPages,
  devAppWin?: ApplicationConfigWithPages
): ApplicationConfigWithPages {
  switch (app.baselineId) {
    case APP_USAGE_APP:
      return mapAppUsageConfig(app, devApp);
    case APP_USAGE_APP_W:
      return mapAppUsageWindowsConfig(app, devApp, devAppWin);
    case APP_USAGE_SHIFT_APP:
      return mapAppUsageShiftConfig(app, devApp);
    case APP_USAGE_SHIFT_APP_W:
      return mapAppUsageShiftWindowsConfig(app, devApp, devAppWin);
    case BATTERY_APP:
      return mapBatteryUsageConfig(app, devApp);
    case BATTERY_APP_W:
      return mapBatteryUsageWindowsConfig(app, devApp, devAppWin);
    case WEBAPP_USAGE_APP:
      return mapWebAppUsageConfig(app, devApp);
    case DATA_USAGE_APP:
      return mapDataUsageConfig(app, devApp);
    case DATA_USAGE_APP_W:
      return mapDataUsageWindowsConfig(app, devApp, devAppWin);
    case DEVICE_APP:
      return mapDeviceConfig(app, devApp);
    case DEVICE_APP_W:
      return mapWindowsDeviceConfig(app, devApp);
    case LAST_KNOWN_APP:
      return mapLastKnownConfig(app, devApp);
    case LAST_KNOWN_APP_W:
      return mapLastKnownWindowsConfig(app, devApp, devAppWin);
    case SIGNAL_STRENGTH_APP:
      return mapSignalStrengthConfig(app, devApp);
    case SIGNAL_STRENGTH_APP_W:
      return mapSignalStrengthWindowsConfig(app, devApp, devAppWin);
    case WIFI_APP:
      return mapWifiConfig(app, devApp);
    case WIFI_APP_W:
      return mapWifiWindowsConfig(app, devApp, devAppWin);
    case WATCHLIST_APP:
      return mapWatchlistConfig(app);
    case WATCHLIST_CURRENT_APP:
      return mapWatchlistCurrentConfig(app);
    case WATCHLIST_DEPARTED_APP:
      return mapWatchlistDepartedConfig(app);
    case UTILIZATION_DEVICE_APP:
      return mapUtilizationDeviceConfig(app);
    case UTILIZATION_STORE_APP:
      return mapUtilizationStoreConfig(app);
    case SMART_BATTERY_APP:
      return mapSmartBatteryConfig(app, devApp, devAppWin);
    case APP_SPOTLIGHT_APP:
      return mapAppSpotlightConfig(app, devApp);
    case APP_SPOTLIGHT_APP_W:
      return mapAppSpotlightWindowsConfig(app, devApp, devAppWin);
    case WEB_APP_SPOTLIGHT_APP:
      return mapWebAppSpotlightConfig(app);
    default:
      console.debug(`App ${app.id} unmapped (${app.baselineId})`);
      return app;
  }
}

export function mapAppConfigs(apps: ApplicationConfigWithPages[]): ApplicationConfigWithPages[] {
  const deviceApps = apps
    .filter(app => app.baselineId === DEVICE_APP)
    .map(app => mapAppConfig(app, apps.filter(app => app.baselineId === SMART_BATTERY_APP)[0]));
  const deviceAppsWindows = apps
    .filter(app => app.baselineId === DEVICE_APP_W)
    .map(app => mapAppConfig(app, deviceApps[0]));
  const otherApps = apps
    .filter(app => app.baselineId !== DEVICE_APP && app.baselineId !== DEVICE_APP_W)
    .map(app => mapAppConfig(app, deviceApps[0], deviceAppsWindows[0]));
  return apps.map(
    app =>
      deviceApps.find(da => da.id === app.id) ||
      deviceAppsWindows.find(da => da.id === app.id) ||
      otherApps.find(da => da.id === app.id)
  );
}
